import { useState, useEffect, useContext } from "react";
import '../../Admin Master/Transport Master/modemaster.css';
import { getApi, postApi } from "../../Admin Master/Area Control/Zonemaster/ServicesApi";
import Swal from "sweetalert2";
import Select from 'react-select';
import 'react-toggle/style.css';
import { refeshPend } from "../../../App";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import Modal from 'react-modal';


function ScanbyAirway() {

    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const [getScan, setGetScan] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);
    const [selectAll, setSelectAll] = useState(false);
    const [selectedScanRows, setSelectedScanRows] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedDocketNos, setSelectedDocketNos] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const { hubFun } = useContext(refeshPend);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [fromDate, setFromDate] = useState(firstDayOfMonth);
        const [toDate, setToDate] = useState(today);
    const statusOptions = [
        { value: "Arrived", label: "Arrived" },
        // (maybe you meant "Return"?)
    ];
    const [formData, setFormData] = useState({
        DocketNo: [],
        Inscan_Status: "",
        Inscan_Remark: "",
        docketNo: "",
    })

    const fetchData = async () => {
        setLoading(true);
        try {
            const login = JSON.parse(localStorage.getItem("Login"));
            const formatDate = (date) => {
        const d = new Date(date);
        return d.toISOString().split("T")[0]; // ✅ SAFE
    };
    
            const response = await getApi(
                `/Inscan/pendingInscan?&DocketNo=${searchQuery}&branchCode=${login?.Branch_Code}&pageNumber=${currentPage}&pageSize=${rowsPerPage}&FromDate=${fromDate}&ToDate=${toDate}`
            );
            const currentPageData = response?.data || [];
            setGetScan(currentPageData);
            // ✅ USE BACKEND COUNT
            setTotalRecords(response?.totalCount || 0);
    
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };
        useEffect(() => {
            fetchData();
        }, [currentPage, rowsPerPage, toDate,fromDate,searchQuery]);



    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(Number(event.target.value));
        setCurrentPage(1);
    };

    const handleSelectAll = () => {
        const newState = !selectAll;
        setSelectAll(newState);

        if (newState) {
            // Select All
            setSelectedRows(getScan.map((_, index) => index));                    // row index array
            setSelectedDocketNos(getScan.map(m => m.DocketNo));                   // all docket numbers
            setSelectedScanRows([...getScan]);                                // entire row data
        } else {
            // Unselect All
            setSelectedRows([]);
            setSelectedDocketNos([]);
            setSelectedScanRows([]);
        }
    };

    const handleRowSelect = (index, docketNo, n) => {
        const already = selectedRows.includes(index);
        const updatedRows = already ? selectedRows.filter(i => i !== index) : [...selectedRows, index];
        if (already) {
            setSelectedDocketNos(selectedDocketNos.filter(docket => docket !== docketNo));
            setSelectedScanRows(selectedScanRows.filter(row => row.DocketNo !== docketNo));
        } else {
            setSelectedDocketNos([...selectedDocketNos, docketNo]);
            setSelectedScanRows([
                ...selectedScanRows,
                getScan.find(data => data.DocketNo === docketNo)
            ]);
        }
        setSelectedRows(updatedRows);
        setSelectAll(updatedRows.length === n);
    };

    const handleFind = () => {
            // Convert to string if numbers come
            const doc = String(formData.docketNo).trim();
    
            if (!doc) {
                Swal.fire({
                    icon: "warning",
                    title: "Empty",
                    text: `Enter docket number!`
                });
                return;
            }
    
            // Check availability in Manifest list
            const found = getScan.find(m => String(m.DocketNo) === doc);
    
            if (!found) {
                Swal.fire({
                    icon: "error",
                    title: "Not Found!",
                    text: `Docket No ${doc} not exists in Manifest List`
                });
                return;
            }
    
            // If already selected → stop
            if (selectedDocketNos.includes(doc)) {
                Swal.fire({
                    icon: "warning",
                    title: "Already Selected",
                    text: `Docket No ${doc} is already added`
                });
                return;
            }
    
            // Add to lists
            setSelectedDocketNos([...selectedDocketNos, doc]);
            setSelectedScanRows([...selectedScanRows, found]);
    
            // If row index required, find and push
            const index = getScan.findIndex(m => String(m.DocketNo) === doc);
            setSelectedRows(prev => [...prev, index]);
    
            // Auto selectAll if length matches
            setSelectAll(selectedRows.length + 1 === getScan.length);
    
            Swal.fire({
                icon: "success",
                title: "Added Successfully",
                text: `Docket No ${doc} added to selection`
            });
        };
    

  


    const totalPages = Math.ceil(totalRecords / rowsPerPage);

    const handlePreviousPage = () => currentPage > 1 && setCurrentPage(currentPage - 1);
    const handleNextPage = () => currentPage < totalPages && setCurrentPage(currentPage + 1);

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
        setCurrentPage(1);
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

         if(JSON.parse(localStorage.getItem("Login"))?.Branch_Code==="ALB")
            {
                Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'You Can not scan data,please login the branch',
            });
            return;
            }
        if (selectedDocketNos.length === 0) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Please select at least one Docket No before submitting the form.',
            });
            return;
        }
        const requestPayload = {
            DocketNo: selectedDocketNos,
            SessionLocationCode: JSON.parse(localStorage.getItem("Login"))?.Branch_Code,
            Inscan_Status: formData.Inscan_Status,
            Inscan_Remark: formData.Inscan_Remark
        };

        try {
            const response = await postApi('/Inscan/generateInscan', requestPayload);
            Swal.fire({
                icon: 'success',
                title: 'Success',
                text: 'Data has been successfully generated!',
                timer: 2000,
                showConfirmButton: false,
            });
            setFormData({
                Inscan_Status: "",
                Inscan_Remark: "",
            });
            setSelectedRows([]);
            setSelectedDocketNos([]);
            setSelectedScanRows([]);
            await fetchData();
            hubFun();
        } catch (error) {
            console.error("Error submitting Inscan: ", error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Something went wrong while generating data. Please try again.',
            });
        }
    };

   

    return (
        <>

            <div className="container1 py-0" style={{ padding: "0px", }}>
                <form action="" style={{ padding: "0px", margin: "0px", background: " #f2f4f3" }} onSubmit={handleSubmit}>
                    <div className="fields2">
                        <div className="input-field3">
                            <label>Status</label>
                            <Select
                                options={statusOptions}
                                value={statusOptions.find(opt => opt.value === formData.Inscan_Status) || null}
                                onChange={(selectedOption) =>
                                    setFormData({
                                        ...formData,
                                        Inscan_Status: selectedOption ? selectedOption.value : ""
                                    })
                                }
                                placeholder="Select Status"
                                required
                                isSearchable
                                classNamePrefix="blue-selectbooking"
                                className="blue-selectbooking"
                                menuPortalTarget={document.body} // ✅ Moves dropdown out of scroll container
                                styles={{
                                    placeholder: (base) => ({
                                        ...base,
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis"
                                    }),
                                    menuPortal: base => ({ ...base, zIndex: 9999 }) // ✅ Keeps dropdown on top
                                }}
                            />
                        </div>

                        <div className="input-field2">
                            <label>Remark</label>
                            <input type="text" placeholder="Enter Remark" value={formData.Inscan_Remark}
                                onChange={(e) => setFormData({ ...formData, Inscan_Remark: e.target.value })} />
                        </div>

                        <div className="input-field2" >
                                <label htmlFor="" style={{ whiteSpace: "nowrap" }}>Bulk Scant</label>
                                <button type="button" className="ok-btn" style={{ height: "35px", width: "100%", fontSize: "14px", lineHeight: "1" }}
                                    onClick={() => { setModalIsOpen(true) }}>Bulk Scan</button>
                        </div>

                        <div className="input-field2">
                            <label>Docket No</label>
                            <input type="tel" placeholder="Enter Docket No"
                                value={formData.docketNo} onChange={(e) => setFormData({ ...formData, docketNo: e.target.value })}
                            />
                        </div>
                        

                        <div className="bottom-buttons" style={{ marginTop: "22px", }}>
                            <button type="button" className="ok-btn" style={{ width: "60px" }} onClick={handleFind}>Find</button>
                            <button className="ok-btn" type="submit" style={{ width: "70px" }}>Submit</button>
                            <button type="button" className="ok-btn" style={{ width: "70px" }}>Cancel</button>
                        </div>
                    </div>
                </form>


               <div className="table-container">
                    <table className="table table-bordered table-sm" style={{whiteSpace:"nowrap"}}>
                        <thead className="table-sm">
                            <tr>
                                <th >Sr.No</th>
                                <th >Branch.Code</th>
                                <th >Branch.Name</th>
                                <th >Docket.No</th>
                                <th >Date</th>
                                <th >Manifest.Destination</th>
                                <th >Manifest.No</th>
                                <th >Manifest.Date</th>
                                <th >Customer.Name</th>
                                <th >Consignee.Name</th>
                                <th >Origin</th>
                                <th >Destination</th>
                                <th >QTY</th>
                                <th >Weight</th>
                                
                                </tr>
                        </thead>
                        <tbody>
                            {
                            selectedScanRows.map((scan, index) => (
                                 
                                    <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{scan.Branch_Code}</td>
                                    <td>{scan.Branch_Name}</td>
                                    <td>{scan.DocketNo}</td>
                                    <td>{scan.BookDate}</td>
                                    <td>{scan.Manifest_Destination}</td>
                                    <td>{scan.ManifestNo}</td>
                                    <td>{scan.ManifestDt}</td>
                                    <td>{scan.Customer_Name}</td>
                                    <td>{scan.Consignee_Name}</td>
                                    <td>{scan.FromDest}</td>
                                    <td>{scan.ToDest}</td>
                                    <td>{scan.qty}</td>
                                    <td>{scan.actualWt}</td>
                                   
                                </tr>
                                    

                            ))}
                        </tbody>
                    </table>
                </div>

                <Modal overlayClassName="custom-overlay" isOpen={modalIsOpen}
                                        className="custom-modal-createmanifest" contentLabel="Modal">
                                        <div className="custom-modal-content">
                                            <div className="header-tittle" style={{ display: "flex", flexDirection: "row" }}>
                                                <header style={{ width: "95%", textAlign: "center" }}>Pending Manifest Data</header>
                                                <button className="ok-btn" style={{ width: "5%", height: "100%", backgroundColor: "red" }}
                                                    onClick={() => setModalIsOpen(false)}>
                                                    <i className="bi bi-x-lg"></i>
                                                </button>
                                            </div>
                                            <div className='container2' style={{ borderRadius: "0px", padding: "20px" }}>
                                                <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", width: "100%", gap: "50px" }}>
                                                    <div className="search-input" style={{ marginBottom: "10px" }}>
                                                        <input
                                                            className="add-input1"
                                                            type="text"
                                                            placeholder="search"
                                                            value={searchQuery}
                                                            onChange={handleSearchChange}
                                                            style={{ marginLeft: "0%" }}
                                                        />
                                                        <button type="submit" title="search">
                                                            <i className="bi bi-search"></i>
                                                        </button>
                                                    </div>
                                                    <div className="input-field" style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
                                                                                            <label style={{ marginTop: "8px", textAlign: "end" }}>From Date</label>
                                                                                            <DatePicker
                                                                                                selected={fromDate}
                                                                                                onChange={(date)=>setFromDate(date)}
                                                                                                dateFormat="dd/MM/yyyy"
                                                                                                className="form-control form-control-sm"
                                                                                                style={{ width: "120px", marginLeft: "10px" }}
                                                                                            />
                                                                                        </div>
                                                    
                                                                                        <div className="input-field" id="datepicker-portal" style={{ display: "flex", flexDirection: "row", gap: "10px", marginRight: "50px" }}>
                                                                                            <label style={{ marginTop: "8px", textAlign: "end" }}>To Date</label>
                                                                                            <DatePicker
                                                                                                selected={toDate}
                                                                                               onChange={(date)=>setToDate(date)}
                                                                                                dateFormat="dd/MM/yyyy"
                                                                                                className="form-control form-control-sm"
                                                                                                style={{ width: "120px", marginLeft: "10px" }}
                                                                                            />
                                                                                        </div>
                
                                                    <div className="bottom-buttons">
                                                        <button style={{ marginTop: "0px" }} className="ok-btn" onClick={()=>setModalIsOpen(false)}>Submit</button>
                                                    </div>
                                                </div>
                                                <div className='table-container' style={{ maxHeight: "300px", overflowY: "auto" }}>
                                                    <table className='table table-bordered table-sm' style={{ whiteSpace: "nowrap" }}>
                                                        <thead className='table-sm'>
                                                            <tr style={{ position: "sticky", top: 0, zIndex: 2 }}>
                                                                <th scope="col">
                                                                    <input type="checkbox" style={{ height: "15px", width: "15px" }} checked={selectAll}
                                                                        onChange={handleSelectAll} />
                                                                </th>
                                                                
                                <th >Sr.No</th>
                                <th >Branch.Code</th>
                                <th >Branch.Name</th>
                                <th >Docket.No</th>
                                <th >Date</th>
                                <th >Manifest.Destination</th>
                                <th >Manifest.No</th>
                                <th >Manifest.Date</th>
                                <th >Customer.Name</th>
                                <th >Consignee.Name</th>
                                <th >Origin</th>
                                <th >Destination</th>
                                <th >QTY</th>
                                <th >Weight</th>
                                
                                </tr>
                                                        </thead>
                                                        <tbody className='table-body'>
                
                                                            {
                                                                    getScan.map((scan, index) => (
                                                                        <tr key={index}>
                                                                            <td scope="col">
                                                                                <input type="checkbox" style={{ height: "15px", width: "15px" }} checked={selectedRows.includes(index)}
                                                                                    onChange={() => handleRowSelect(index, scan.DocketNo, getScan.length)} />
                                                                            </td>
                                                                            <td>{index + 1}</td>
                                    <td>{scan.Branch_Code}</td>
                                    <td>{scan.Branch_Name}</td>
                                    <td>{scan.DocketNo}</td>
                                    <td>{scan.BookDate}</td>
                                    <td>{scan.Manifest_Destination}</td>
                                    <td>{scan.ManifestNo}</td>
                                    <td>{scan.ManifestDt}</td>
                                    <td>{scan.Customer_Name}</td>
                                    <td>{scan.Consignee_Name}</td>
                                    <td>{scan.FromDest}</td>
                                    <td>{scan.ToDest}</td>
                                    <td>{scan.qty}</td>
                                    <td>{scan.actualWt}</td>
                                                                        </tr>
                
                                                                    ))}
                
                                                        </tbody>
                                                    </table>
                                                </div>
                
                                                <div style={{ display: "flex", flexDirection: "row" }}>
                                                    <div className="pagination">
                                                        <button className="ok-btn" onClick={handlePreviousPage} disabled={currentPage === 1}>
                                                            {'<'}
                                                        </button>
                                                        <span style={{ color: "#333", padding: "5px" }}>Page {currentPage} of {totalPages}</span>
                                                        <button className="ok-btn" onClick={handleNextPage} disabled={currentPage === totalPages}>
                                                            {'>'}
                                                        </button>
                                                    </div>
                
                                                    <div className="rows-per-page" style={{ display: "flex", flexDirection: "row", color: "black", marginLeft: "10px" }}>
                                                        <label htmlFor="rowsPerPage" style={{ marginTop: "16px", marginRight: "10px" }}>Rows per page:</label>
                                                        <select
                                                            style={{ height: "40px", width: "60px", marginTop: "10px" }}
                                                            id="rowsPerPage"
                                                            value={rowsPerPage}
                                                            onChange={handleRowsPerPageChange}
                                                        >
                                                            <option value={5}>5</option>
                                                            <option value={10}>10</option>
                                                            <option value={25}>25</option>
                                                            <option value={50}>50</option>
                                                            <option value={100}>100</option>
                                                            <option value={200}>200</option>
                                                            <option value={500}>500</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Modal >

                
            </div>
        </>
    );
};


export default ScanbyAirway;